import { TRANSFER_GROUP_MODULE } from '@app/routes';

export const TRANSFER_GROUP_AUTO_RESTOCK_TYPE = 'auto_restock';
export const GROUP_AUTO_RESTOCK_ROUTE = `/${TRANSFER_GROUP_MODULE}/auto-restock`;
